import { BasicLazyParams } from '../../../../../utile';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

export const SEARCH_TYPE_OPTIONS = [
    { label: 'Student Name', value: 'studentName' },
    { label: 'Enrollment Number', value: 'enrollmentNumber' }
];

export const TOAST_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARN: 'warn',
    INFO: 'info'
};

export const APPROVAL_STATUS = {
    APPROVE: 'APROVE',
    REJECT: 'REJECT'
};

export const TRANSFER_FLAGS = {
    APPROVE: 'APROVE',
    REJECT: 'REJECT'
};

export const ADJUSTMENT_TYPES = {
    SYSTEM: 'system',
    MANUAL: 'manual'
};

export const INITIAL_STATE = {
    isLoading: false,
    filterData: null,
    columns: [{ columnName: 'Created At', isVisible: false, id: 'createDateTime' }],
    isUserNameSearch: false,
    username: '',
    boardId: null,
    classId: null,
    groupId: null,
    sectionIds: [],
    boards: [],
    classes: [],
    groups: [],
    sections: [],
    branchLevels: {},
    lazyParams: BasicLazyParams,
    changeRequests: [],
    selectedUser: [],
    globalSearch: '',
    totalRecords: 0,
    isDialogOpenForApproveStudent: false,
    isRejectTransferDialogOpen: false,
    rowData: {},
    dropdownsData: {},
    flagForTransfer: null,
    isUserEnrollSearch: false,
    searchValue: '',
    searchLevel: 1,
    branchId: null,
    branchName: null,
    dropdownsDilogData: {},
    filterbranchId: null,
    focused: false,
    filters: {
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'firstName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'lastName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'enrollmentId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        isManualAdjustment: false,
        advanceAdjustmentType: 'system',
        'contactPersonName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'parentContactNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'totalFee': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        'refundRaisedAmt': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
    },
    globalFilterValue: '',
    effectiveDate: '',
    feeStructureInfo: [],
    selectedFeePlan: null,
    selectedFeeStructure: [],
    installmentData: [],
    oneTimeFees: [],
    newFeeResponse: {},
    oldFeeInfo: [],
    onShowOldFeeInfo: false,
    onShowNewFeeInfo: false,
    isShowInstallmentInfo: false,
    advanceAdjustmentType: 'system',
    isManualAdjustment: false,
    totalClosingDueAmt: 0,
    totalClosingAdvance: 0,
    manualAdjustmentFeeInfo: {},
    showResponseDialog: false,
    admissionChangeCheckResponse: [],
    message: '',
    searchType: SEARCH_TYPE_OPTIONS[0].value
};

export const COLUMN_STYLES = {
    DEFAULT: { width: '15rem', height: '6rem' },
    WIDER: { width: '17rem', height: '6rem' }
};

export const BUTTON_STYLES = {
    APPROVE: {
        backgroundColor: '#007bff',
        color: '#fff',
        borderRadius: '10px'
    },
    REJECT: {
        backgroundColor: '#E0E0E0',
        borderRadius: '10px',
        border: 0
    },
    REFRESH: {
        backgroundColor: '#076EFF',
        color: 'white',
        borderRadius: '8px'
    }
};
